var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-textarea',{staticClass:"mb-5",attrs:{"rows":"2","placeholder":"설명을 입력해주세요","autofocus":_vm.auto_focus,"lazy":"true"},on:{"blur":_vm.updateChartList},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }